//알림메일 상단 안내 문구 ("OOO 님" 아래 문단) 기본값과 채우기 함수
//기본 문구는 백엔드 index.js 의 MAIL_INTRO_KO / MAIL_INTRO_EN 과 같은 내용으로 유지 ({행사명}·{이름} 은 발송 시 실제 값으로 바뀜)
const INTRO_KO = "{행사명} 사전등록 신청이 완료 되었습니다.\n행사장 입장을 위한 입장권(출입증) 발급 전용 QR코드가 발급되었으니\n아래 안내사항에 따라 잊지 마시고 참석하여 주시기 바랍니다.";
const INTRO_EN = "Thank you for registering for {행사명}.\nYour registration is complete, and a QR code has been issued for your ticket(name badge) to enter the venue.\nPlease follow the instructions below to ensure a smooth check-in.";

const mailintro = {

    //템플릿 언어(0: 국문, 그 외: 영문)의 기본 문구
    defaulttext(lan){
        return lan == 0 ? INTRO_KO : INTRO_EN;
    },

    //문구가 비어 있으면 템플릿 언어의 기본 문구를 미리 채움 (화면에서 바로 고칠 수 있게)
    fill(vm, item){
        if(item != null && (item.ETEMP_INTRO == null || String(item.ETEMP_INTRO).trim().length == 0)){
            vm.$set(item, 'ETEMP_INTRO', mailintro.defaulttext(item.ETEMP_LAN));
        }
        return item;
    },

    //사용자가 템플릿 언어를 바꿨을 때 (언어 선택 칸 @change, item.ETEMP_LAN 은 이미 바뀐 값)
    //문구가 비었거나 기본 문구 그대로면 바뀐 언어의 기본 문구로 바로 교체, 직접 고친 문구면 확인 후 교체
    changelan(vm, item){
        if(item == null) return;
        const next = mailintro.defaulttext(item.ETEMP_LAN);
        const cur  = item.ETEMP_INTRO == null ? '' : String(item.ETEMP_INTRO);
        if(cur === next) return;
        if(cur.trim().length == 0 || cur === INTRO_KO || cur === INTRO_EN){
            vm.$set(item, 'ETEMP_INTRO', next);
            return;
        }
        vm.$confirm(vm.$t('emailtemp_intro_lanconfirm'))
            .then(() => { vm.$set(item, 'ETEMP_INTRO', mailintro.defaulttext(item.ETEMP_LAN)); })
            .catch(() => {});   //취소하면 고친 문구 유지
    },

}

export default mailintro
